


















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import TabGroupRouted from "@/shared/components/ui/TabGroupRouted.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import EmployerAddressForm from "../settings/EmployerAddressForm.vue";
import PlanDetail from "../profile/PlanDetail.vue";
import Payroll from "../profile/Payroll.vue";
import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: {
      TabGroupRouted,
      Tab,
      EmployerAddressForm,
      PlanDetail,
      Payroll,
      SettingsNavigation
    }
})

export default class EmployerAddress extends Vue {
  userStore = useUserStore();
}

